import DocumentActions from 'notebook/documents/DocumentActions';
import DocumentStore from 'notebook/documents/DocumentStore';
import {collectAllStepDocumentIds} from 'procedures/design/step-config/stepManagementUtils';
import {ProcedureWithMetadata} from 'procedures/ProcedureDomainTypes';

export default function flushDocumentStore(procedure: ProcedureWithMetadata): void {
  for (const method of procedure.flowchart.nodes) {
    const openStepDocumentIds = collectAllStepDocumentIds(method.stepGroups);
    for (const docId of openStepDocumentIds) {
      if (DocumentStore.inStore(docId)) {
        DocumentActions.close(docId);
      }
    }
  }
}
